import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3dd3800d")

_pushScopeId("data-v-3dd3800d")
const _hoisted_1 = { class: "form-page" }
const _hoisted_2 = { class: "form-page__title -bold" }
const _hoisted_3 = { class: "form-page__subtitle" }
const _hoisted_4 = {
  key: 1,
  class: "form-page__content"
}
const _hoisted_5 = {
  key: 2,
  class: "form-page__footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_ctx.state.isClose)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "close pi pi-times",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode("h3", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, undefined, true)
    ]),
    _createVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "subtitle", {}, undefined, true)
    ]),
    (_ctx.$slots.content)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.footer || _ctx.$slots.action)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", null, [
            _createVNode("div", null, [
              (_ctx.$slots.footer)
                ? _renderSlot(_ctx.$slots, "footer", { key: 0 }, undefined, true)
                : _createCommentVNode("", true)
            ]),
            (_ctx.$slots.action)
              ? _renderSlot(_ctx.$slots, "action", { key: 0 }, undefined, true)
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})